var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoreBigcommerce(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#34313F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bigcommerce-1",
    transform: "translate(8769.143 375.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    className: "st0",
    d: "M-8717.02-319.65h9.95c2.83,0,4.62-1.56,4.62-4.06c0-2.36-1.79-4.06-4.62-4.06h-9.95 c-0.32,0-0.59,0.25-0.61,0.57v6.98C-8717.61-319.9-8717.34-319.65-8717.02-319.65z M-8717.02-303.57h10.28 c3.16,0,5.05-1.61,5.05-4.44c0-2.45-1.79-4.44-5.05-4.44h-10.28c-0.32,0-0.59,0.25-0.61,0.57v7.69 C-8717.62-303.84-8717.35-303.57-8717.02-303.57L-8717.02-303.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    className: "st0",
    d: "M-8680.59-364.38l-29.44,29.34h4.81c7.5,0,11.94,4.72,11.94,9.86c0,4.06-2.74,7.03-5.66,8.35 c-0.28,0.11-0.42,0.43-0.31,0.71c0.06,0.16,0.19,0.28,0.36,0.33c3.4,1.32,5.8,4.86,5.8,9.01c0,5.85-3.92,10.52-11.51,10.52h-20.85 c-0.32,0-0.59-0.25-0.61-0.57v-22.22l-32.32,32.18c-0.27,0.27-0.27,0.7,0,0.98c0.13,0.13,0.3,0.2,0.48,0.2h77.71 c0.29,0,0.52-0.23,0.52-0.52v-77.75c0.06-0.28-0.12-0.55-0.4-0.6C-8680.28-364.59-8680.47-364.53-8680.59-364.38z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreBigcommerce);
export default __webpack_public_path__ + "static/media/store-bigcommerce.ccdb530384d878cf506b6738c1fc4593.svg";
export { ForwardRef as ReactComponent };